import {
  DueDisplayOptions,
  PlannedOccurrence,
  Task,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { endOfDay, isAfter, startOfDay } from 'date-fns';

import { getNextOccurrence } from './get-next-occurrence';
import { getTaskPlanning } from './get-task-planning';

export type GetTaskDueOccurrenceOptions = {
  plannedOccurrence?: PlannedOccurrence;
  displayDue: DueDisplayOptions[];
  today: Timestamp;
  displayDate?: Timestamp;
  weekStartsOn: WeekDays;
};

export const getTaskDueOccurrence = (
  task: Task,
  {
    plannedOccurrence,
    displayDue,
    today,
    displayDate,
    weekStartsOn,
  }: GetTaskDueOccurrenceOptions,
) => {
  if (plannedOccurrence || !displayDue.includes(DueDisplayOptions.Future)) {
    return undefined;
  }
  const dateToMeasureFrom = endOfDay(displayDate ?? today);

  if (
    task.endStrategy?.deadline &&
    isAfter(task.endStrategy.deadline, endOfDay(dateToMeasureFrom))
  ) {
    return getTaskPlanning(task, {
      startDate: startOfDay(dateToMeasureFrom),
      endDate: dateToMeasureFrom,
      today,
      weekStartsOn,
    })[0];
  }

  return getNextOccurrence(task, { today, weekStartsOn, from: displayDate });
};
